export function getEnvFromLocation() {
  switch (window.location.hostname) {
    case 'app.dev.payup.com':
      return 'dev';
    case 'app.qa.payup.com':
      return 'qa';
    case 'app.payup.com':
      return 'prod';
    case 'pay.dev.billroute.com':
      return 'dev';
    case 'pay.qa.billroute.com':
      return 'qa';
    case 'pay.billroute.com':
      return 'prod';
    default:
      return 'other';
  }
}
